// Paths in api.js are joined as `${baseURL}${url}` (e.g. `admin/profile`).
// Without a trailing slash on the base, you get invalid URLs like
// `http://localhost:5000admin/profile`.
const rawBase = (process.env.REACT_APP_BASE_URL || "").trim();
export const baseURL =
  rawBase === "" ? "" : rawBase.endsWith("/") ? rawBase : `${rawBase}/`;
export const secretKey = process.env.REACT_APP_SECRET_KEY;

export const agoraId = process.env.REACT_APP_AGORA_ID;

// Subdomain routing - editable via .env
export const subdomainAdmin = process.env.REACT_APP_SUBDOMAIN_ADMIN || "admin";
export const subdomainContentCreator = process.env.REACT_APP_SUBDOMAIN_CONTENT_CREATOR || "content-creator";
